import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, NavigationStart, Router,ActivatedRoute } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { Observable } from 'rxjs';
import { AccountService } from '../services/account-services';
import { ModalSessionExpiredComponent } from '../modals/session-expired/session-expired.component';


@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    modalReference!: BsModalRef;
    modalOpen = false;

    constructor(private router: Router,
        private LoginService: AccountService,
        private route:ActivatedRoute,
        public ModalService: BsModalService,
    ) {
        this.router.events.subscribe(event => {
            if (this.modalOpen && event instanceof NavigationStart) {
                this.ModalService.hide();
                this.modalOpen = false;
                history.pushState(null, '', router.url);
            }
        });

    }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        const accessToken = route.queryParamMap.get('accessToken');
        const instance:any = route.queryParamMap.get('instance');

        const loginStatus = this.LoginService.ifLoggedIn();

        if (loginStatus === 'Valid') {
            const requiredRoles = route.data['roles'] as Array<string>;
            const userRole = localStorage.getItem('userType');

            if (requiredRoles && !requiredRoles.includes(userRole!)) {
                this.router.navigate(['/access-denied'], { replaceUrl: true });
                return false;
            }
            return true;
        } else if (loginStatus === 'Expired') {

            return new Promise(resolve => {
                this.modalOpen = true;
                const initialState = {
                    userName: localStorage.getItem('userName') || ''
                };
                this.modalReference = this.ModalService.show(ModalSessionExpiredComponent, {
                    initialState,
                    ignoreBackdropClick: true,
                    class: 'modal-dialog-centered animated bounceInRight',
                    backdrop: 'static'
                });

                this.modalReference.content.onClose.subscribe((response: { Status: any; }) => {
                    this.modalOpen = false;
                    if (response.Status) {
                        resolve(true);
                    } else {
                        localStorage.clear();
                        this.router.navigate(['/login']);
                        resolve(false);
                    }
                });
            });
        } else if(accessToken){
            localStorage.setItem('accessToken',accessToken);
            localStorage.setItem('userType','hospitalUser');
            localStorage.setItem('instanceId',instance);
            return true;
        }else {
            localStorage.clear();
            this.router.navigate(['/login']);
            return false;
        }
    }

}
